import React from "react";

const Health: React.FC = () => {
  return <div data-testid="health-check">healthy</div>;
};

export default Health;
